import React from "react";
import { Button } from "@/components/ui/button";
import RecordInspector, { useRecordInspector } from "@/components/app/RecordInspector";
import ProjectQaCenter from "@/components/app/ProjectQaCenter";
import { Lightbulb, ArrowRight } from "@phosphor-icons/react";
import { PanelHeader, EmptyHint, useFetchList } from "./_shared";

export default function LessonsPanel({ project }) {
  const inspector = useRecordInspector();
  const { items, loading, err } = useFetchList(`/lessons-learned?project_id=${project.id}`, [project.id]);
  return (
    <div data-testid={`panel-lessons-${project.id}`}>
      <PanelHeader icon={Lightbulb} title="Lessons Learned" subtitle="F-PM-29 · captured for portfolio learning"
        action={<ProjectQaCenter project={project} trigger={<Button size="sm" variant="outline">Manage <ArrowRight size={11} className="ml-1" /></Button>} />} />
      {loading && <div className="text-[11px] text-slate-500">Loading…</div>}
      {err && <div className="rounded-md border border-amber-200 bg-amber-50/60 px-2 py-1.5 text-[11px] text-amber-800">{err}</div>}
      {!loading && !err && items.length === 0 && <EmptyHint message="No lessons captured yet for this project." />}
      {items.length > 0 && (
        <ul className="space-y-1.5">
          {items.slice(0, 20).map((r) => (
            <li key={r.id}
                onClick={() => inspector.open(r, { title: r.title || "Lesson", subtitle: r.category || r.lesson_type || "" })}
                data-testid={`lesson-row-${r.id}`}
                className="flex flex-wrap items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1.5 text-sm cursor-pointer hover:bg-slate-50">
              <span className="font-mono-alt text-[10px] uppercase tracking-wider text-slate-500 w-24 truncate">{r.category || r.lesson_type || "—"}</span>
              <span className="min-w-0 flex-1 truncate">{r.title || r.description || "Untitled lesson"}</span>
              {r.recommendation && <span className="text-[10px] text-slate-500">→ recommended</span>}
            </li>
          ))}
        </ul>
      )}
      <RecordInspector {...inspector.props} />
    </div>
  );
}
